var exports = {
  "x": "xcc377c0b--f3309b--offer",
  "eh": "xcc377c0b--f3309b--room",
  "h_": "xcc377c0b--f3309b--description",
  "Wc": "xcc377c0b--f3309b--area",
  "q9": "xcc377c0b--f3309b--price",
  "O5": "xcc377c0b--f3309b--offers",
  "nf": "xcc377c0b--f3309b--link",
  "z8": "xcc377c0b--f3309b--props-count",
};

module.exports = exports;
